import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { use100vh } from 'react-div-100vh';
import { SnackbarProvider, Loader } from 'fronton-react';
import { Footer } from 'pages/common/components/Footer';
import { DataContext, RouteContext, TData } from 'entries/common/widgets/context';
import { Content } from './content';
import { Fallback } from '../fallback/fallback';

export const MainPage = ({ data }: { data: TData }) => {
  const [route, setRoute] = useState('surface');
  const [calculatorParams, setCalcParams] = useState({});
  const [isError, setIsError] = useState(false);
  const height = use100vh();
  const calculatedHeight = height ? height - 48 : 'calc(100vh - 48px)';

  useEffect(() => {
    const api = data?.api;
    if (!__IS_SERVER__ && data?.productId && api) {
      api
        .get(`/getParametersCalculator/${data?.productId}?regionId=${data?.regionId}`, {})
        .then(res => {
          setIsError(false);
          const surfaces = Object.keys(res.surface);
          const isSurfaceOne =
            surfaces.length === 1 &&
            Object.keys(get(res, 'surface[surfaces[0]].enums.baseSurface', {})).length <= 1;
          const currentRoute = isSurfaceOne ? 'dimensions' : 'surface';
          setCalcParams(prev => ({ ...prev, ...data, surfaces: res, isSurfaceOne }));
          setRoute(currentRoute);
        })
        .catch(() => {
          setCalcParams({});
          setIsError(true);
        });
    }
  }, [data]);

  if (isError) {
    return <Fallback />;
  }

  if (isEmpty(calculatorParams)) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  return (
    <DataContext.Provider value={calculatorParams as TData}>
      <SnackbarProvider>
        <RouteContext.Provider value={{ context: route, setContext: setRoute }}>
          <Layout height={calculatedHeight}>
            <Container>
              <Content />
              <Footer />
            </Container>
          </Layout>
        </RouteContext.Provider>
      </SnackbarProvider>
    </DataContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 112px);

  @media (--only-mobile) {
    height: calc(100vh - 48px);
  }
`;

const Layout = styled.div<{ height: number | string }>`
  width: 100%;
  height: ${props => props.height}px;
`;
